import { useParams, Link } from 'react-router-dom';
import { Calendar, Clock, ArrowLeft, ArrowRight } from 'lucide-react';

export default function BlogPost() {
  const { slug } = useParams();

  const posts: { [key: string]: any } = {
    'repair-vs-replace-furnace': {
      title: 'When to Repair vs Replace Your Furnace',
      date: '2026-01-15',
      readTime: '5 min read',
      category: 'Furnaces',
      content: `
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Making the decision between repairing your existing furnace or investing in a new one is one of the most important HVAC choices homeowners face.</p>
        
        <h2>Key Factors to Consider</h2>
        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. When evaluating your furnace, consider these critical factors:</p>
        
        <h3>Age of Your Furnace</h3>
        <p>Most furnaces have a lifespan of 15-20 years. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. If your furnace is approaching or exceeding this age, replacement often makes more financial sense than continued repairs.</p>
        
        <h3>Repair Frequency and Cost</h3>
        <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. A good rule of thumb: if repair costs exceed 50% of replacement cost, or if you're calling for repairs more than once per year, it's time to replace.</p>
        
        <h3>Energy Efficiency</h3>
        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium. Newer furnaces operate at 90-98% efficiency, while older models may only achieve 60-70%. The energy savings alone can justify replacement.</p>
        
        <h2>When Repair Makes Sense</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Repairs are often the right choice when:</p>
        <ul>
          <li>Your furnace is less than 10 years old</li>
          <li>The repair is minor (under $500)</li>
          <li>This is the first significant repair needed</li>
          <li>Your energy bills are still reasonable</li>
        </ul>
        
        <h2>When to Replace</h2>
        <p>Consider replacement when facing these situations:</p>
        <ul>
          <li>Furnace is over 15 years old</li>
          <li>Repair costs exceed $1,500</li>
          <li>Multiple repairs needed annually</li>
          <li>Rising energy bills despite maintenance</li>
          <li>Uneven heating throughout home</li>
        </ul>
        
        <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.</p>
      `
    },
    'heat-pump-rebates-ontario-2026': {
      title: 'Heat Pump Rebates in Ontario 2026',
      date: '2026-01-08',
      readTime: '7 min read',
      category: 'Heat Pumps',
      content: `
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Heat pumps are becoming increasingly popular in Ontario, and government rebates make them more affordable than ever.</p>
        
        <h2>Available Rebates for 2026</h2>
        <p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Here's a breakdown of current rebate programs:</p>
        
        <h3>Canada Greener Homes Grant</h3>
        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris. The federal program offers up to $5,000 for qualifying heat pump installations, plus $600 for home energy evaluations.</p>
        
        <h3>Enbridge Home Efficiency Rebate</h3>
        <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore. Additional rebates up to $1,500 available for qualifying systems in Enbridge service areas.</p>
        
        <h2>Qualification Requirements</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. To qualify for rebates, your heat pump must meet specific efficiency ratings and be installed by a licensed contractor.</p>
        
        <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis.</p>
      `
    },
    'ac-freezing-up': {
      title: 'Why Your AC is Freezing Up',
      date: '2025-12-20',
      readTime: '4 min read',
      category: 'Air Conditioning',
      content: `
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Finding ice on your air conditioner during summer is a common but serious problem that needs immediate attention.</p>
        
        <h2>Common Causes of AC Freezing</h2>
        <p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Several factors can cause your AC to freeze:</p>
        
        <h3>Restricted Airflow</h3>
        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris. Dirty air filters are the #1 cause of frozen AC units. When airflow is restricted, the evaporator coil gets too cold and ice forms.</p>
        
        <h3>Low Refrigerant</h3>
        <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore. A refrigerant leak causes pressure to drop, leading to freezing. This requires professional repair.</p>
        
        <h3>Dirty Coils</h3>
        <p>Excepteur sint occaecat cupidatat non proident. Dust and debris on evaporator coils insulate them, preventing proper heat absorption and causing ice buildup.</p>
        
        <h2>What to Do When Your AC Freezes</h2>
        <ol>
          <li>Turn off your AC immediately</li>
          <li>Switch fan to "ON" (not AUTO) to help thaw ice</li>
          <li>Check and replace air filter if dirty</li>
          <li>Allow ice to completely melt (2-4 hours)</li>
          <li>Call a technician if problem persists</li>
        </ol>
        
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      `
    }
  };

  const post = posts[slug || ''];

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Post not found</h1>
          <Link to="/blog" className="text-[var(--color-slate-blue)] hover:underline">
            Back to Blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-[var(--color-slate-blue)] text-white py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Link 
            to="/blog" 
            className="inline-flex items-center gap-2 text-gray-200 hover:text-white mb-6"
          >
            <ArrowLeft size={20} />
            Back to Blog
          </Link>
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">{post.title}</h1>
          <div className="flex items-center gap-4 text-gray-200">
            <span className="bg-[var(--color-warm-amber)] text-white px-3 py-1 rounded text-sm font-semibold">
              {post.category}
            </span>
            <div className="flex items-center gap-1">
              <Calendar size={16} />
              <span>{new Date(post.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</span>
            </div>
            <div className="flex items-center gap-1">
              <Clock size={16} />
              <span>{post.readTime}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none" dangerouslySetInnerHTML={{ __html: post.content }} />
          
          {/* CTA Box */}
          <div className="mt-12 bg-[var(--color-neutral-bg)] rounded-lg p-8 text-center">
            <h3 className="text-2xl font-bold mb-4 text-[var(--color-text-dark)]">
              Need Professional HVAC Service?
            </h3>
            <p className="text-gray-600 mb-6">
              Don't let HVAC problems get worse. Our licensed technicians are ready to help.
            </p>
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-2 bg-[var(--color-slate-blue)] text-white px-6 py-3 rounded font-semibold hover:bg-opacity-90 transition-colors"
            >
              Schedule Service Call
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}